// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"3ea3529d","990":"109c2489"}[chunkId] + ".chunk.js";
};